import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';
import apiClient from '../../../hooks/apiClient';

const buildWarehouseKey = (uuid) => ['warehouses', 'detail', uuid];

const fetchWarehouse = async (uuid) => {
  const response = await apiClient.get(`warehouses/${uuid}`);
  return response.data;
};

export const useWarehousesByUuids = (uuids = [], enabled = false) => {
  const uniqueUuids = useMemo(
    () => [...new Set((uuids || []).filter(Boolean))],
    [uuids]
  );

  const queries = useQueries({
    queries: uniqueUuids.map((uuid) => ({
      queryKey: buildWarehouseKey(uuid),
      queryFn: () => fetchWarehouse(uuid),
      enabled: enabled && Boolean(uuid),
      staleTime: 5 * 60 * 1000,
      retry: false,
    })),
  });

  const warehouses = useMemo(
    () => queries.map((query) => query.data).filter(Boolean),
    [queries]
  );

  const warehousesByUuid = useMemo(
    () =>
      warehouses.reduce((acc, warehouse) => {
        if (warehouse?.uuid) {
          acc[warehouse.uuid] = warehouse;
        }
        return acc;
      }, {}),
    [warehouses]
  );

  const isLoading = enabled && queries.some((query) => query.isLoading);

  return { warehouses, warehousesByUuid, isLoading };
};
